const sqlQ = {
    topic: 'SQL',
    tables: [
        `CREATE TABLE Employees (
            EmployeeID INT PRIMARY KEY,
            EmployeeName VARCHAR(50),
            DepartmentID INT,
            Salary DECIMAL(10, 2),
            HireDate DATE
        )`,
        `CREATE TABLE Departments (
            DepartmentID INT PRIMARY KEY,
            DepartmentName VARCHAR(50)
        )`,
        `CREATE TABLE Performance_Reviews (
            ReviewID INT PRIMARY KEY,
            EmployeeID INT,
            ReviewDate DATE,
            CONSTRAINT fk_employee FOREIGN KEY (EmployeeID) REFERENCES
            Employees(EmployeeID)
        )`,
        `CREATE TABLE Review_Scores (
            ReviewID INT,
            Score INT,
            CONSTRAINT fk_review FOREIGN KEY (ReviewID) REFERENCES
            Performance_Reviews(ReviewID)
        )`,
    ],
    sqlQuestionss: [
        {
            questionId: 11,
            question: `Write a SQL query to retrieve the department name, the total number of employees in each department`,
            correctAnswer: `with cte as (
                    select d.deptname, count(e.employeeID), round(avg(e.salary), 0)
                    from employee e
                    join departments d on e.departmentID = d.departmentID
                    group by d.departmentID
                    )`
        },
        {
            questionId: 12,
            question: `the average salary of employees in that department rounded to the nearest integer, and the highest salary among employees in that department.`,
            correctAnswer: `select d.DepartmentName, count(e.EmployeeID), round(avg(e.salary), 0),
                    max(e.salary)
                    from employee e
                    left join departments d on e.DepartmentID = d.DepartmentID
                    group by d.DepartmentID;`
        },
        {
            questionId: 13,
            question: `Write a SQL query to find the top three employees with the highest average review scores, along with their respective departments`,
            correctAnswer: `with cte as (
                    select avg(r.score) as average, d.DepartmentName
                    from employees e
                    join performance_reviews pr on e.EmployeeID = pr.EmployeeID
                    join review_scores rv on rv.ReviewID = pr.ReviewID
                    join departments d on d.DepartmentID = e.DepartmentID
                    group by d.DepartmentID
                    )
                    select top 3 average
                    from cte
                    order by average desc;`
        },
        {
            questionId: 14,
            question: `If two employees have the same average score, prioritize the one with the earliest hire date.`,
            correctAnswer: `select top 3 average
                    from cte
                    order by average desc, hire_date asc;`
        }
    ]
};

export default sqlQ;
